import { forwardRef, useMemo } from 'react'

import { css } from 'twind/css'

import { UnstyledButton } from '@core/components/twind/Button/Button'

import { commonCss, primaryCss, secondaryCss } from './OtovaButton.twind'

export interface OtoButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  overrideCSS?: ReturnType<typeof css>
  variant?: 'primary' | 'secondary'
}

/**
 * OTOVA Button Component to apply common styling.
 */
export const OtoButton = forwardRef<HTMLButtonElement, OtoButtonProps>(
  ({ variant, disabled, children, onClick, overrideCSS, ...rest }, ref) => {
    const buttonCss = useMemo(() => {
      switch (variant) {
        case 'primary':
          return primaryCss
        case 'secondary':
          return secondaryCss
      }
    }, [variant])

    return (
      <UnstyledButton
        ref={ref}
        overrideCSS={css(commonCss, buttonCss, overrideCSS)}
        onClick={(e) => {
          onClick?.(e)
        }}
        disabled={disabled}
        {...rest}
      >
        {children}
      </UnstyledButton>
    )
  },
)
